import { render, staticRenderFns } from "./ComplaintDetailAnnexes.vue?vue&type=template&id=0d80fadb"
import script from "./ComplaintDetailAnnexes.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailAnnexes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports